import React from 'react';
import correctSymbol from '../../assets/correct-symbol.png'
import noStopping from '../../assets/no-stopping.png'

export default () => {
  return (
    <div className="tab-pane fade show active" id="pills-berinduk" role="tabpanel" aria-labelledby="pills-berinduk-tab" style={{ borderTopRightRadius: '10px', borderTopLeftRadius: '10px'}}>
      <table className="table-bordered table table-syarat" style={{fontSize: '12px'}}>
        <tr>
          <td colspan="2" style={{fontWeight: '600'}}>Persyaratan PSrE Berinduk</td>
          <td style={{fontWeight: '600'}}>PSrE Instansi</td>
          <td style={{fontWeight: '600'}}>PSrE non-Instansi</td>
          </tr>
        <tr>
          <td className="text-center">1</td>
          <td class="text-left">Surat Permohonan Pengakuan Status Berinduk</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>        
        </tr>
       <tr>
          <td className="text-center">2</td>
          <td class="text-left">Proposal Penyelenggara Sertifikasi Elektronik</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">3</td>
          <td class="text-left">Dokumen Tanda Daftar Penyelenggara Sistem Elektronik</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">4</td>
          <td class="text-left">Akte Pendirian Perusahaan</td>      
          <td><img src={noStopping} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">5</td>
          <td class="text-left">Surat Izin Usaha, Bidang Teknologi Informasi</td>
          <td><img src={noStopping} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">6</td>
          <td class="text-left">Surat Pernyataan Fasilitas dan Peralatan di Indonesia</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">7</td>
          <td class="text-left">Prosedur Pengoperasian Fasilitas dan Peralatan</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">8</td>
          <td class="text-left">Interoperabilitas Mengacu Pada Standar Kominfo</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">9</td>
          <td class="text-left">Salinan Bukti Laporan Sertifikasi Atas Audit Terhadap Standar Fasilitas dan Peralatan</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">10</td>
          <td class="text-left">Dokumen Rencana Bisnis, Rencana Keberlangsungan Bisnis, Rencana Penanggulangan Bencana dan Dokumen Laporan Pengujian Sistem Elektronik</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">11</td>
          <td class="text-left">CP/CPS sesuai dengan CP/CPS PSrE Induk</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">12</td>
          <td class="text-left">Salinan Sertifikat Kelaikan Sistem Elektronik</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">13</td>
          <td class="text-left">Tidak Berinduk dan Tidak Menjadi Induk pada PSrE lain</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">14</td>
          <td class="text-left">Memiliki 12 Orang Ahli Operasional</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
              <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">15</td>
          <td class="text-left">Modal Rp 30 Miliar</td>
          <td><img src={noStopping} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">16</td>
          <td class="text-left">Jaminan kerugian Pemilik Sertifikat Elektronik</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">17</td>
          <td class="text-left">Pakta Integritas dan Rekam Jejak</td>
          <td><img src={noStopping} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">18</td>
          <td class="text-left">Surat Keterangan Non Pailit</td>
          <td><img src={noStopping} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
      </table>
    </div>
  )
}